import axios from "axios";
import { authHeader } from "./auth-header";

const api = () => process.env.REACT_APP_API_URL || "";

const list = () =>
  axios.get(api() + "store/list", { headers: authHeader() });

const create = (data) =>
  axios.post(api() + "store/create", data, { headers: authHeader() });

const assignPincodes = (storeId, data) =>
  axios.post(`${api()}store/${storeId}/assign-pincodes`, data, {
    headers: authHeader(),
  });

/**
 * Super-admin style store policy (B2B + delegated staff), not RBAC templates.
 * Expected: PATCH `admin/stores/:storePublicId` with JSON body (0/1 or booleans).
 * If your backend uses another route, change only this function.
 */
const patchPlatformPolicy = (storePublicId, data) =>
  axios.patch(
    `${api()}admin/stores/${encodeURIComponent(storePublicId)}`,
    data,
    {
      headers: authHeader(),
    }
  );

export default { list, create, assignPincodes, patchPlatformPolicy };
